export default "__VITE_ASSET__96161265__"